import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      copyright="四川朗坦数智科技有限公司 版权所有"
      style={{

      }}
      links={[
        {
          key: '网站备案号: 蜀ICP备2025159928号-1',
          title: '网站备案号: 蜀ICP备2025159928号-1',
          href: 'https://beian.miit.gov.cn/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
